import toast from "react-hot-toast";
import { LogOut, Settings, ShieldCheck, UserCircle } from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";
import image from "../../../assets/images/Vaslolo-completo.svg";
import { Role } from "../../../assets/js/roles.js";
import { useAuth } from "../../../hooks/useAuth";
import { useCategories } from "../../../hooks/useCategories";
import { HttpError } from "../../../lib/http/HttpClient";
import { hasAnyRole } from "../../../routes/guards/RequireRole";
import styles from "./Navbar.module.scss";

const Navbar = () => {
  const navigate = useNavigate();
  const { user, loading, logout } = useAuth();
  const { categories = [], loading: loadingCats } = useCategories();
  const roles = user?.data?.roles || [];
  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login", { replace: true });
    } catch (error) {
      toast.error(error instanceof HttpError
        ? error.body?.description || "Ha ocurrido un error"
        : "Ha ocurrido un error");
    }
  };
  return (
    <nav className={`container ${styles.navbar}`} aria-label="Navegación principal">
      <div className={styles.topRow}>
        <NavLink to="/" className={styles.logo} aria-label="Vaslola, inicio">
          <img width={100} height={27} src={image} alt="Vaslola" />
        </NavLink>
        <ul className={styles.navLinks}>
          <li><NavLink to="/todos" className={({ isActive }) => isActive ? styles.active : ""}>Todos</NavLink></li>
          {loadingCats ? <li>Cargando...</li> : (categories || []).map(cat => (
            <li key={cat.id}><NavLink to={`/${cat.slug}`} state={{ title: cat.name }}
              className={({ isActive }) => isActive ? styles.active : ""}>{cat.name}</NavLink></li>
          ))}
          <li><NavLink to="/contacto" className={({ isActive }) => isActive ? styles.active : ""}>Contacto</NavLink></li>
          <li className={styles.mobileNavItem}><NavLink to="/abonos" state={{ title: "abonos" }}
            className={({ isActive }) => isActive ? styles.activeAbonoNavlink : styles.abonoNavlink}>Abonos</NavLink></li>
          <li className={styles.mobileNavItem}><NavLink to="/tienda" state={{ title: "tienda" }}
            className={({ isActive }) => isActive ? styles.activeAbonoNavlink : styles.abonoNavlink}>Tienda online</NavLink></li>
        </ul>
        <div className={styles.actions}>
          {(loading ||
            (user && hasAnyRole(roles, [Role.ADMIN, Role.CLUB_ADMIN]))) && (
            <div className={styles.adminSlot} aria-hidden={loading || undefined}>
              {!loading && user && hasAnyRole(roles, [Role.ADMIN]) && (
                <NavLink to="/backoffice" className={styles.adminBtn}>
                  <Settings size={14} aria-hidden="true" /><span>Admin</span>
                </NavLink>
              )}
              {!loading && user && hasAnyRole(roles, [Role.CLUB_ADMIN]) && (
                <NavLink to="/backoffice-clubes" className={styles.adminBtn}>
                  <ShieldCheck size={14} aria-hidden="true" /><span>Admin Clubes</span>
                </NavLink>
              )}
            </div>
          )}
          {!loading && user && <>
            <NavLink to="/usuario" className={styles.iconBtn} aria-label="Perfil" title="Perfil"><span className={styles.tooltip}>Perfil</span><UserCircle size={18} /></NavLink>
            <button type="button" onClick={handleLogout} className={styles.iconBtn} aria-label="Salir" title="Salir"><span className={styles.tooltip}>Salir</span><LogOut size={16} /></button>
          </>}
          {!loading && !user && <>
            <NavLink to="/login" className={styles.loginBtn}>Iniciar sesión</NavLink>
            <NavLink to="/login" className={styles.iconBtnIniciarSesion} aria-label="Iniciar sesión">
              <span className={styles.tooltip}>Iniciar sesión</span><UserCircle size={18} aria-hidden="true" />
            </NavLink>
          </>}
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
